module.exports = __webpack_public_path__ + "static/img/map.812af8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 1